import { gql } from "@apollo/client"

export const UpdateSubscription = gql`
mutation UpdateSubscription($updateSubscriptionId: ID!, $content: contentSubscription!) {
  updateSubscription(id: $updateSubscriptionId, content: $content) {
    status
  }
}
`